import React from "react";
import { Phone } from "lucide-react";
import VoiceAgentsList from "@/components/voice/VoiceAgentsList";
import { VoiceAgent, VoiceAgentStats } from "@/services/voiceAgentService";

interface VoiceAgentsSectionProps {
  voiceAgentsEnabled: boolean;
  onCreateVoiceAgent: () => void;
  agents?: VoiceAgent[];
  isLoading?: boolean;
  agentStats?: Record<string, VoiceAgentStats>;
}

export const VoiceAgentsSection: React.FC<VoiceAgentsSectionProps> = ({
  voiceAgentsEnabled,
  onCreateVoiceAgent,
  agents,
  isLoading,
  agentStats,
}) => {
  if (!voiceAgentsEnabled) return null;

  return (
    <div className="space-y-6">
      <div className="flex items-center justify-between">
        <div className="flex items-center gap-3">
          <Phone className="h-6 w-6 text-green-600" />
          <h2 className="text-xl font-semibold">Voice Agents</h2>
        </div>
      </div>
      <VoiceAgentsList
        onCreateAgent={onCreateVoiceAgent}
        agents={agents}
        isLoading={isLoading}
        agentStats={agentStats}
      />
    </div>
  );
};
